import { Redirect, useParams } from "react-router-dom";
import { Feature, useFeatureFlags } from "context/FeatureFlag";
import { supportingManagementPath } from "components/Documents/supportingMetadata";

// Keep existing bookmarks working after moving uploads out of the process steps.
export const SupportingDocuments = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const { isFeatureEnabled } = useFeatureFlags();
  return (
    <Redirect
      to={
        isFeatureEnabled(Feature.SupportingDocuments)
          ? supportingManagementPath(projectId)
          : `/projects/${projectId}`
      }
    />
  );
};
